import { Injectable } from "@angular/core";
import { MCAuthoritiesEventsCivilAdministration } from "@maslul/common-services";

@Injectable({
    providedIn: 'root'
})
export class MIAuthoritiesEventsCivilAdministration extends MCAuthoritiesEventsCivilAdministration {
}
